import React from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";

import dialog from "./dialog.module.scss";

import { DialogFactory, DIALOG } from "./DialogFactory";

export const Dialog = ({ isOpen = true, metaData }) => {
  return isOpen ? (
    <div className={dialog["wrapper"]}>
      <div className={dialog["card"]}>
        {DialogFactory(DIALOG.Language, metaData)}
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state: any) => ({
  isOpen: state.dialogReducer.isOpen,
  metaData: state.dialogReducer,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);
